import React from 'react';
import _ from 'underscore';
import { Alert, FormGroup, ControlLabel, Row, Col, FormControl, Button, } from 'react-bootstrap';
import LocationStore from 'stores/LocationStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import GeofenceMap from './GeofenceMap';
class CreateAddressForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            location: props.location,
        };
    }
    handleLocationDrag(lat, lng) {
        this.setState((prevState) => {
            const location = prevState.location;
            location.lat = lat;
            location.lng = lng;
            return { location };
        });
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState((prevState) => {
            if (prevState.location.street !== newProps.location.street) {
                const location = _.extend({}, prevState.location, newProps.location);
                return { location };
            }
            return {};
        });
    }
    handleFieldChange(field, value) {
        this.setState((prevState) => {
            let location = prevState.location;
            location[field] = value;
            const suite_or_apt = location.suite_or_apt
                ? `${location.suite_or_apt}, `
                : '';
            location.address = `${location.street}, ${suite_or_apt}${location.city}, ${location.state}, ${location.zipcode}`;
            return { location };
        }, () => {
            LocationStore.clearCreateLocationError();
        });
    }
    componentWillUnmount() {
        this.setState({ location: {} });
    }
    handleSave() {
        const location = this.state.location;
        location._type = 'point';
        location._sub_type = 'Address';
        this.props.onCreateLocation(location);
    }
    render() {
        const { t } = this.props;
        if (!this.state.location)
            return null;
        const location = this.state.location;
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("h4", null, t('GEOFENCE')),
                    React.createElement(GeofenceMap, { location: location, height: 250, onLocationDrag: this.handleLocationDrag.bind(this) }))),
            React.createElement(Row, { className: "mt-1" },
                React.createElement(Col, { xs: 6 },
                    React.createElement(ControlLabel, null, t('LONGITUDE')),
                    React.createElement(FormControl, { disabled: true, value: location.lng })),
                React.createElement(Col, { xs: 6 },
                    React.createElement(ControlLabel, null, t('LATITUDE')),
                    React.createElement(FormControl, { disabled: true, value: location.lat }))),
            React.createElement(Row, { style: { marginTop: 10 } },
                React.createElement(Col, { xs: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('NAME'))),
                        React.createElement(FormControl, { value: location.name || '', onChange: (e) => this.handleFieldChange('name', e.target.value) })))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('ADDRESS'))),
                        React.createElement(FormControl, { onChange: (e) => this.handleFieldChange('street', e.target.value), value: location.street || '' }))),
                React.createElement(Col, { xs: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, t('ADDRESS_2')),
                        React.createElement(FormControl, { onChange: (e) => this.handleFieldChange('suite_or_apt', e.target.value), value: location.suite_or_apt || '' })))),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('CITY'))),
                        React.createElement(FormControl, { onChange: (e) => this.handleFieldChange('city', e.target.value), value: location.city || '' }))),
                React.createElement(Col, { xs: 3 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('STATE'))),
                        React.createElement(FormControl, { maxLength: 2, onChange: (e) => this.handleFieldChange('state', e.target.value), value: location.state || '' }))),
                React.createElement(Col, { xs: 3 },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, null, titleize(t('POSTAL_CODE'))),
                        React.createElement(FormControl, { maxLength: 5, onChange: (e) => this.handleFieldChange('zipcode', e.target.value), value: location.zipcode || '' })))),
            this.props.error && (React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(Alert, { bsStyle: "danger" }, this.props.error)))),
            React.createElement(Row, { style: { marginTop: 10 } },
                React.createElement(Col, { xs: 8 }),
                React.createElement(Col, { xs: 4 },
                    React.createElement("div", { className: "float-right" },
                        React.createElement(Button, { onClick: () => this.handleSave(), bsStyle: "primary" },
                            this.state.locationPending && (React.createElement("i", { className: "fa fa-circle-o-notch fa-spin mr-2" })),
                            titleize(t('SAVE'))),
                        React.createElement(Button, { onClick: () => this.props.onCreateLocationCancel(), bsStyle: "link" }, titleize(t('CANCEL'))))))));
    }
}
export default withTranslation()(CreateAddressForm);
